export function hasValue<T extends string | boolean | number | undefined | null>(
  val: T,
  def: string | number | undefined
) {
  return val === '' || val === null || val === undefined ? def : val;
}
